export const handleApiError = (error) => {
  // FIXED: Log the full error for debugging in development only
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.error('API Error:', {
      message: error.message,
      response: error.response,
      request: error.request,
      config: error.config
    });
  }

  if (!error.response) {
    // Network error, CORS issue, or server not reachable
    if (error.message === 'Network Error') {
      return 'Cannot connect to server. Please ensure the backend server is running at http://localhost:8000';
    }
    return 'Network error: ' + error.message + '. Please check your connection and ensure the backend is running.';
  }

  const status = error.response.status;
  const data = error.response.data;

  switch (status) {
    case 401:
      return 'Session expired. Please login again.';

    case 403:
      return 'You do not have permission to perform this action.';

    case 404:
      return 'The requested resource was not found.';

    case 422:
      if (data.errors) {
        return Object.values(data.errors).flat().join(', ');
      }
      return data.message || 'Validation error.';

    case 429:
      const retryAfter = error.response.headers['retry-after'];
      return 'Too many requests. Please try again ' + (retryAfter ? 'after ' + retryAfter + ' seconds' : 'later') + '.';

    case 500:
      // Check if there's a specific error message from the backend
      if (data.error && data.error.message) {
        return data.error.message;
      }
      if (data.message) {
        return data.message;
      }
      return 'Server error. Please try again later.';

    default:
      return data.message || (data.error && data.error.message) || 'An unexpected error occurred.';
  }
};
